export const DEFAULT_AUTH_PATH = '/dashboard/garage';
